module.exports = __webpack_public_path__ + "static/media/resume2.97ea03c2.jpg";